import {
  FETCH_CONFIGURATIONS_REQUEST,
  FETCH_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATIONS_FAILURE,
  FETCH_CONFIGURATION_REQUEST,
  FETCH_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_FAILURE,
  UPDATE_CONFIGURATIONS_REQUEST,
  UPDATE_CONFIGURATIONS_FAILURE,
  UPDATE_CONFIGURATIONS_SUCCESS,
  DELETE_CONFIGURATIONS_REQUEST,
  DELETE_CONFIGURATIONS_FAILURE,
  DELETE_CONFIGURATIONS_SUCCESS,
  DUPLICATE_CONFIGURATIONS_REQUEST,
  DUPLICATE_CONFIGURATIONS_FAILURE,
  DUPLICATE_CONFIGURATIONS_SUCCESS,
  OPEN_EDIT_PAGE_CONFIGURATION,
  CHECK_CONFIGURATION_REQUEST,
  CHECK_CONFIGURATION_SUCCESS,
  CHECK_CONFIGURATION_FAILURE,
  CLEAR_CONFIGURATION_ERRORS,
  CLEAR_CONFIGURATION_SUCCESS,
  VERIFY_CONFIGURATION_FAILURE,
  VERIFY_CONFIGURATION_SUCCESS,
  VERIFY_CONFIGURATION_REQUEST,
  CLEAR_VERIFY_CONFIGURATION_ERRORS,
  CLEAR_VERIFY_CONFIGURATION_SUCCESS,
  CHECK_CONFIGURATIONS_EXPIRED_REQUEST,
  CHECK_CONFIGURATIONS_EXPIRED_SUCCESS,
  CHECK_CONFIGURATIONS_EXPIRED_FAILURE,
} from './actionTypes';

const initialState = {
  configurations: [],
  configuration: null,
  loadingConfig: false,
  errorConfig: null,
  configurationAdded: null,
  editItemId: null,

  checkConfiguration: null,
  loadingCheckConfig: false,
  errorCheckConfig: null,

  loadingCheckConfigExpired: false,
  checkConfigurationExpired: null,
  errorCheckConfigExpired: null,

  verifiedConfiguration: null,
  verifyConfigurationSuccess: null,
  loadingVerifyConfig: false,
  errorVerifyConfig: null,
};

const Configurations = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loadingConfig: true,
        errorConfig: null,
        configurationAdded: false
      };
    case FETCH_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        loadingConfig: false,
        configurations: action.payload,
      };
    case FETCH_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        loadingConfig: false,
        errorConfig: action.payload,
      };
    case FETCH_CONFIGURATION_REQUEST:
      return {
        ...state,
        loadingConfig: true,
        errorConfig: null,
        configurationAdded: false
      };
    case FETCH_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingConfig: false,
        configuration: action.payload.data,
        errorCheckConfig: action.payload,
      };
    case FETCH_CONFIGURATION_FAILURE:
      return {
        ...state,
        loadingConfig: false,
        errorConfig: action.payload,
      };
    case UPDATE_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loadingConfig: true,
        errorConfig: null,
        configurationAdded: false
      };
    case UPDATE_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        loadingConfig: false,
        configuration: null,
        configurationAdded: true
      };
    case UPDATE_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        loadingConfig: false,
        errorConfig: action.payload,
      };
    case DELETE_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loadingConfig: true,
        errorConfig: null,
        configurationAdded: false
      };
    case DELETE_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        configurationAdded: true,
        loadingConfig: false,
        configurations: state.configurations.filter(configuration => configuration.id !== action.payload),
      };
    case DELETE_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        loadingConfig: false,
        errorConfig: action.payload,
      };
    case DUPLICATE_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loadingConfig: true,
        errorConfig: null,
        configurationAdded: false
      };
    case DUPLICATE_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        loadingConfig: false,
        configurationAdded: true,
      };
    case DUPLICATE_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        loadingConfig: false,
        errorConfig: action.payload,
      };
    case OPEN_EDIT_PAGE_CONFIGURATION:
          return {
            ...state,
            editItemId: action.payload.id,
          };
    case CHECK_CONFIGURATION_REQUEST:
      return {
        ...state,
        loadingCheckConfig: true,
        errorCheckConfig: null,
      };
    case CHECK_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingCheckConfig: false,
        checkConfiguration: action.payload?.data,
        errorCheckConfig: action.payload,
      };
    case CHECK_CONFIGURATION_FAILURE:
      return {
        ...state,
        loadingCheckConfig: false,
        errorCheckConfig: action.payload,
      };
    case VERIFY_CONFIGURATION_REQUEST:
      return {
        ...state,
        loadingVerifyConfig: true,
        errorVerifyConfig: null,
      };
    case VERIFY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        verifiedConfiguration: action.payload?.data,
        verifyConfigurationSuccess: true,
        loadingVerifyConfig: false,
        errorVerifyConfig: null,
      };
    case VERIFY_CONFIGURATION_FAILURE:
      return {
        ...state,
        loadingVerifyConfig: false,
        verifyConfigurationSuccess: false,
        errorVerifyConfig: action.payload,
      };
    case CLEAR_CONFIGURATION_ERRORS:
      return {
        ...state,
        errorConfig: null,
        errorCheckConfig: null,
      };
    case CLEAR_VERIFY_CONFIGURATION_ERRORS:
      return {
        ...state,
        errorVerifyConfig: null,
        verifyConfigurationSuccess: null,
        verifiedConfiguration: null,
        loadingVerifyConfig: false,
      };
    case CLEAR_VERIFY_CONFIGURATION_SUCCESS:
      return {
        ...state,
        verifiedConfiguration: null,
        verifyConfigurationSuccess: null,
        loadingVerifyConfig: false,
      };      
    case CLEAR_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configurationAdded: null,
        checkConfiguration: null,
      };
    case CHECK_CONFIGURATIONS_EXPIRED_REQUEST:
      return {
        ...state,
        loadingCheckConfigExpired: true,
        errorCheckConfigExpired: null,
        checkConfigurationExpired: null,
      };
    case CHECK_CONFIGURATIONS_EXPIRED_SUCCESS:
      return {
        ...state,
        loadingCheckConfigExpired: false,
        checkConfigurationExpired: action.payload,
        errorCheckConfigExpired: null,
      };
    case CHECK_CONFIGURATIONS_EXPIRED_FAILURE:
      return {
        ...state,
        loadingCheckConfigExpired: false,
        errorCheckConfigExpired: action.payload,
        checkConfigurationExpired: null,
      };
      
    default:
      return state;
  }
};

export default Configurations;